<template>
  <v-container>
    <v-row
      align="center"
      justify="center"
    >
      <v-col class="prescription-header__container">
        <OsiguLogo class="prescription-header__logo" />
        <h3
          class="text-h3 secondary--text"
          v-if="!isMobile"
        >
          {{ $t('dispensing.delivery') }}
        </h3>
        <h3
          class="text-center text-h4 prescription-header__title"
          :class="{
            'secondary--text': isSecondaryText,
            'osg-black--text pt-6': isBlackText
          }"
          v-if="isMobile"
        >
          {{ mobileTitle }}
        </h3>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import OsiguLogo from '@/assets/images/svg/OsiguLogo';

  export default {
    name: 'PrescriptionHeader',
    components: {
      OsiguLogo,
    },
    props: {
      mobileTitle: {
        type: String,
      },
      isSecondaryText: {
        type: Boolean,
        default: false,
      },
      isBlackText: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.xsOnly
      },
    },
  };
</script>

<style lang="scss" scoped>
  .prescription-header {
    &__container {
      display: flex;
      justify-content: center;
      flex-direction: column;
      max-height: 125px;
    }

    &__logo {
      height: 100px;
      width: 100px;
    }
  }

  @media (max-width: 600px) {
    .prescription-header {
      &__container {
        max-height: 80px;
      }

      &__title {
        margin: 0 auto;
        width: 70%;
      }
    }
  }
</style>
